// "use server";
// import qs from "qs";
import { stringify } from "qs";
import endpoints from "../../lib/endpoints";
import { makeApiRequest } from "../../lib/fetchClient";
import { baseUrl } from "../../lib/util";

export const getBrands = async ({ params, limit }) => {
  const url = baseUrl + endpoints.brands;

  let queryParams = {
    locale: params?.lang,
    pagination: {
      limit: limit || 25,
    },
  };

  // const querySting = qs.stringify(queryParams, { encodeValuesOnly: true });
  const querySting = stringify(queryParams, { encodeValuesOnly: true });

  try {
    const res = await makeApiRequest(
      url + `?${querySting}`,
      "GET",
      null,
      ["brands"],
      true
    );

    return res;
  } catch (error) {
    console.log(error?.message);
  }
};
